<template>
    <div>
        <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="180px">
            <el-row>
                <panel>
                    <el-col :span="24">
                        <el-form-item label="姓名：" prop="f__name" :rules="{required: true, message: '不能为空'}">
                            <el-input v-model="dataForm.f__name"  style="width: 30%"></el-input> <el-button type="primary" @click="search('dataForm')">查询</el-button>
                            <el-button type="" @click="reSet()">清空</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="身份证号：" prop="f__identity"  :rules="{required: true, message: '不能为空'}">
                            <el-input v-model="dataForm.f__identity" style="width: 30%"></el-input>
                        </el-form-item>
                    </el-col>
                </panel>
            </el-row>
        </el-form>
        <data-table
            :table-data="tableData"
            :columns="columns"
            :page.sync="page"
            :pageSize.sync="pageSize"
            v-if="show"
        />
        <el-col :span="24" v-if="show">
            <div style="text-align: right"><el-button  type="primary" @click="onSubmit('dataForm')">查询最新风控记录</el-button></div>
        </el-col>


    </div>
</template>

<script>
import xhr from "../../utils/xhr"
import {removeItem} from "../../filters/CommonActions";
import moment from "moment";

export default {
    name: "FaihaiQueryPerson",
    data(){
        return {
            dataForm:{},
            show: false,
            tableData:{
                count: 0,
                data: []
            },
            page: 1,
            pageSize: 20,
            columns:[
                {
                    type: 'index'
                },
                {
                    label: '查询对象',
                    field: 'f__name'
                },
                {
                    label: '查询时间',
                    field: 'f__queryTime',
                    formatter: function (r,c,v) {
                        return moment(v).format('YYYY-MM-DD HH:mm:ss')
                    }
                },
                {
                    label: '相关数据条数',
                    field: 'd__queryId'
                },
                {
                    label: '操作',
                    opts: [
                        {
                            label: '查看',
                            class: 'el-icon-view',
                            clickHandler: (index, row) => {
                                this.$router.push({
                                    name: 'FaihaiQueryPersonView',
                                    query: {
                                        queryId: row.f__queryId
                                    }
                                })
                            },
                        },
                        {
                            label: '删除',
                            class: 'el-icon-delete',
                            clickHandler: (index, row) => {
                                removeItem(
                                    xhr.updateFaihai,
                                    {
                                        'f.queryId' : row.f__queryId
                                    },
                                    res=>{
                                        try {
                                            if(res.data.status == 'success') {
                                                this.getData()
                                            }
                                        }catch (e) {

                                        }
                                    }
                                )
                            },
                        },
                    ]
                }
            ],
            dataFormRules: {
                f__name: [
                    {
                        required: true,
                        message: '不能为空！'
                    }
                ],
            }
        }
    },
    computed:{
        filterParams: {
            get: function() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    /*'xlist.search.t.applicationStatus' : this.applicationStatus,
                    'xlist.search.t.applicationStatus.op' : 'in',
                    'xlist.sort.dataField': 't.applicationDate',
                    'xlist.sort.order': 'desc'*/
                }
            },
            set:function (newVal) {

            }
        }
    },
    methods:{
        reSet:function (){
            this.dataForm={

            }
        },
        getData: function () {
            xhr.getFaihaiList(
                Object.assign({
                    'xlist.search.f.name' : this.dataForm.f__name,
                    'xlist.search.f.name.op' : 'eq',
                    'xlist.search.f.identity' :  this.dataForm.f__identity,
                    'xlist.search.f.identity.op' : 'eq',
                }, this.filterParams, {}),
                res => {
                    try {
                        this.tableData = res.data
                        this.show = true
                    } catch (e) {

                    }
                })
        },

        search: function (formName) {
            let dataForm = this.dataForm
            this.$refs[formName].validate(valid=> {
                if (valid) {
                    this.getData()
                }
            })
        },
        onSubmit: function (formName) {
            let dataForm = this.dataForm
            this.$refs[formName].validate(valid=> {
                if (valid) {
                    dataForm.f__checked = true
                    xhr.updateFaihai(dataForm, res=> {
                        try {
                            if (res.data.status == 'success') {
                                this.getData()
                                this.$router.push({
                                    name: 'FaihaiQueryList'
                                })
                            }
                        } catch (e) {
                        }
                    })

                }
            })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FaihaiQueryPerson.vue